
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/shopping-guide",
      function () {
        return require("private-next-pages/article/shopping-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/shopping-guide"])
      });
    }
  